class BSO_PRODUCT_FACT_SLIDER extends HTMLElement {
  constructor() {
    super();

    this.initSlider();
  }

  initSlider() {
    const OPTIONS = { axis: 'x', loop: true, align: 'center' };
    const viewportNode = this.querySelector('.embla__viewport');
    const emblaApi = EmblaCarousel(viewportNode, OPTIONS, [EmblaCarouselAutoplay(), EmblaCarouselAutoHeight()]);
  }
}

customElements.define('bso-product-fact-slider', BSO_PRODUCT_FACT_SLIDER);
